import { ModalAttachmentContentProps } from '../ModalAttachmentContent';
import { ModalCodeContentProps } from '../ModalCodeContent';
import { ModalDateContentProps } from '../ModalDateContent';
import { ModalImageContentProps } from '../ModalImageContent';
import { ModalLongTextContentProps } from '../ModalLongTextContent';
import { ModalMultiSelectContentProps } from '../ModalMultiSelectContent';
import { ModalSingleSelectContentProps } from '../ModalSingleSelectContent';
import { ModalTextContentProps } from '../ModalTextContent';


type ModalFieldsInternalProps = {
  modalAttachmentContent?: ModalAttachmentContentProps;
  modalDateContent?: ModalDateContentProps;
  modalImageContent?: ModalImageContentProps;
  modalCodeContent?: ModalCodeContentProps;
  modalLongTextContent?: ModalLongTextContentProps;
  modalMultiSelectContent?: ModalMultiSelectContentProps;
  modalTextContent?: ModalTextContentProps;
  modalSingleSelectContent?: ModalSingleSelectContentProps;
};

type ModalFieldsPropsValues = {
  'Attachment': ModalFieldsInternalProps;
  'Date': ModalFieldsInternalProps;
  'Image': ModalFieldsInternalProps;
  'JSON': ModalFieldsInternalProps;
  'LongText': ModalFieldsInternalProps;
  'MultiReference': ModalFieldsInternalProps;
  'MultiSelect': ModalFieldsInternalProps;
  'Number': ModalFieldsInternalProps;
  'ShortText': ModalFieldsInternalProps;
  'SingleReference': ModalFieldsInternalProps;
  'SingleSelect': ModalFieldsInternalProps;
};

const propValues: ModalFieldsPropsValues = {
  'Attachment': {
    modalAttachmentContent: {
      state: 'Default',
    },
  },
  'Date': {
    modalDateContent: {
      state: 'Default',
    },
  },
  'Image': {
    modalImageContent: {
      state: 'Default',
    },
  },
  'JSON': {
    modalCodeContent: {
      state: 'Default',
    },
  },
  'LongText': {
    modalLongTextContent: {
      state: 'Default',
    },
  },
  'MultiReference': {
    modalMultiSelectContent: {
      state: 'Default',
    },
  },
  'MultiSelect': {
    modalMultiSelectContent: {
      state: 'Default',
    },
  },
  'Number': {
    modalTextContent: {
      state: 'Default',
    },
  },
  'ShortText': {
    modalTextContent: {
      state: 'Default',
    },
  },
  'SingleReference': {
    modalSingleSelectContent: {
      state: 'Default',
    },
  },
  'SingleSelect': {
    modalSingleSelectContent: {
      state: 'Default',
    },
  },
};

const getProps = (type: string): ModalFieldsInternalProps => {
  const values: ModalFieldsInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
